import * as api from "./client";

export type DashboardSubscription = {
  id: string;
  firmId: number;
  packageId: string;
  packageName?: string;
  siteStructureId: string | null;
  site: string | null;
  language: string | null;
  startDate: string;
  endDate: string;
  status: string;
  correlationId: string | null;
  metadata: unknown;
};

export type DashboardWarning = {
  type: "expiring_soon" | "no_subscription" | "duplicate";
  siteStructureId?: string;
  subscriptionId?: string;
  subscriptionIds?: string[];
  endDate?: string;
  [key: string]: unknown;
};

export type RegionSummary = {
  active: number;
  expiringSoon: number;
  expired: number;
  cancelled: number;
  total: number;
};

export type CountryGroup = {
  siteStructureId: string;
  name: string;
  subscriptions: DashboardSubscription[];
  summary: RegionSummary;
};

export type RegionGroup = {
  slug: string;
  name: string;
  summary: RegionSummary;
  countries: CountryGroup[];
};

export type FeatureRollupSubscriptionRef = {
  id: string;
  siteStructureId: string | null;
  status: string;
  resolvedStatus: "active" | "expiring_soon" | "expired" | "cancelled";
  featuresNeedingConfiguration: string[];
};

export type FeatureRollupEntry = {
  feature: string;
  state: "current" | "future" | null;
  from?: string;
  until?: string;
  publicationIds: number[];
  subscriptions: FeatureRollupSubscriptionRef[];
  requiresConfiguration: boolean;
};

export type FulfilmentDashboardResponse = {
  firmId: number;
  firmName: string;
  regions: RegionGroup[];
  warnings: DashboardWarning[];
  features: FeatureRollupEntry[];
};

export const fulfilmentDashboardService = {
  getDashboard: async (firmId: string): Promise<FulfilmentDashboardResponse> => {
    return api.get<FulfilmentDashboardResponse>(`/v1/fulfilment/firms/${firmId}/dashboard`);
  },

  refreshPages: async (firmId: string): Promise<void> => {
    await api.post<void>(`/v1/fulfilment/firms/${firmId}/refresh-pages`);
  },
};
